export default "__VITE_ASSET__DGZ4jJdM__"